<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h2>Relatório de Solicitação de Serviço</h2>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">
        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Cliente</mat-label>
            <input
              matInput
              [matAutocomplete]="company"
              formControlName="company"
              (keyup)="filterCompanyOptions($event.target.value)"
            />
            <mat-autocomplete
              #company="matAutocomplete"
              [displayWith]="displayDescription"
            >
              <mat-option
                *ngFor="let company of filteredCompanyOptions"
                [value]="company"
              >
                {{ company?.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Técnico</mat-label>
            <input
              matInput
              [matAutocomplete]="agent"
              formControlName="agent"
              (keyup)="filterAgentOptions($event.target.value)"
            />
            <mat-autocomplete
              #agent="matAutocomplete"
              [displayWith]="displayAgent"
            >
              <mat-option
                *ngFor="let agent of filteredAgentOptions"
                [value]="agent"
              >
                {{ agent?.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start start">
          <mat-form-field color="accent" appearance="outline" fxFlex="20">
            <mat-label>Data inicial</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              placeholder="Data Inicial"
              id="startDate"
              readonly
              formControlName="startDate"
              (dateChange)="onChangeStartDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker color="primary"></mat-datepicker>
          </mat-form-field>

          <mat-form-field color="accent" appearance="outline" fxFlex="20">
            <mat-label>Data Final</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              [min]="minEndDate"
              placeholder="Data Final"
              id="endDate"
              readonly
              formControlName="endDate"
              (dateChange)="onChangeEndDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker color="warn"></mat-datepicker>
          </mat-form-field>
          <mat-icon
            *ngIf="form.get('startDate').value || form.get('endDate').value"
            class="icons"
            matTooltip="Limpar Período"
            matTooltipPosition="right"
            (click)="clearPeriod()"
            >clear</mat-icon
          >
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-md="column"
          fxLayoutAlign="end center"
          class="btn__register__container"
        >
          <button
            mat-raised-button
            type="submit"
            color="primary"
            (click)="onSubmit()"
          >
            Gerar Relatório
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
